import React from 'react';
import BriefContactStatusModalMobile from './BriefContactStatusModalMobile';
import BriefContactStatusModalDesktop from './BriefContactStatusModalDesktop';

type Props = {
  contactStatus: 'success' | 'error' | null;
  clearStatus: () => void;
  isMobileView: boolean;
};

const BriefContactStatusModal = ({
  contactStatus,
  clearStatus,
  isMobileView,
}: Props) => {
  if (!contactStatus) return null;

  return isMobileView ? (
    <BriefContactStatusModalMobile
      contactStatus={contactStatus}
      clearStatus={clearStatus}
    />
  ) : (
    <BriefContactStatusModalDesktop
      contactStatus={contactStatus}
      clearStatus={clearStatus}
    />
  );
};

export default BriefContactStatusModal;
